"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = render;
const vue_1 = require("vue");
const _hoisted_1 = { class: "wf-component wf-options" };
const _hoisted_2 = {
    key: 0,
    class: "nofloat wf-component-title"
};
const _hoisted_3 = {
    key: 1,
    class: "nofloat"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_payment_unit_component = (0, vue_1.resolveComponent)("payment-unit-component");
    const _component_AppButton = (0, vue_1.resolveComponent)("AppButton");
    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_1, [
        (_ctx.showtitle === true)
            ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_2, (0, vue_1.toDisplayString)(_ctx.$t(_ctx.playerinput.title)), 1))
            : (0, vue_1.createCommentVNode)("", true),
        ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)(_ctx.keys, (unit) => {
            return ((0, vue_1.openBlock)(), (0, vue_1.createBlock)(_component_payment_unit_component, {
                key: unit,
                modelValue: _ctx.units[unit],
                "onUpdate:modelValue": ($event) => ((_ctx.units[unit]) = $event),
                modelModifiers: { number: true },
                unit: unit,
                showMax: false,
                description: "",
                onPlus: ($event) => (_ctx.addValue(unit)),
                onMinus: ($event) => (_ctx.reduceValue(unit))
            }, null, 8, ["modelValue", "onUpdate:modelValue", "unit", "onPlus", "onMinus"]));
        }), 128)),
        (_ctx.showsave === true)
            ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_3, [
                (0, vue_1.createVNode)(_component_AppButton, {
                    onClick: _ctx.saveData,
                    title: _ctx.playerinput.buttonLabel
                }, null, 8, ["onClick", "title"])
            ]))
            : (0, vue_1.createCommentVNode)("", true)
    ]));
}
